import React, { useState } from "react";
import Grid from '@mui/material/Grid2';

import { Campaign, PseudoItem, QuestRewards } from "@dndModels";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import StringBox from "@components/input/strings/StringBox";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CurrencyEditor from "@dndComponents/character/inventory/CurrencyEditor";
import CharacterManageInventory from "@dndComponents/character/inventory/manage/CharacterManageInventory";
import DandDButtonBox from "@dndComponents/DandDButtonBoxSimple";
import AddButton from "@components/input/buttons/icon_buttons/AddButton";

interface Props {
  campaign: Campaign;
  reward: QuestRewards;
  onChange: () => void;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function QuestRewardsEdit({ campaign, reward, onChange }: Props) {
  const [adding_items, setAddingItems] = useState(false);
  const [adding_money, setAddingMoney] = useState(false);
  const [ping, setPing] = useState(false);

  const changed = () => {
    setPing(!ping);
    onChange();
  }

  const renderItems = () => {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={12} className="header">
          Items&nbsp;<AddButton onClick={() => setAddingItems(true) } />
        </Grid>
        { reward.items.map((reward_item, key) => {
          const pseudo_item = char_util.getPseudoItem(reward_item.id);
          return (
            <Grid size={12} key={key} container spacing={0} direction="row" className="padded">
              <Grid size={6} style={{ margin: "auto" }}>
                { pseudo_item ? pseudo_item.name : reward_item.id }
              </Grid>
              <Grid size={2} style={{ margin: "auto" }}>
                <StringBox
                  name="Count"
                  value={`${reward_item.count}`}
                  type="number"
                  onBlur={(value: string) => {
                    reward_item.count = Math.max(1, +value);
                    changed();
                  }}
                />
              </Grid>
              <Grid size={3} style={{ margin: "auto" }}>
                <ToggleButtonBox
                  name="Each Member"
                  tooltip="Every party member gets this many"
                  value={reward_item.for_all}
                  onToggle={() => {
                    reward_item.for_all = !reward_item.for_all;
                    changed();
                  }}
                />
              </Grid>
              <Grid size={1} style={{ margin: "auto" }}>
                <DeleteButton
                  onClick={() => {
                    reward.items = reward.items.filter(o => o !== reward_item);
                    changed();
                  }}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  }

  return (
    <>
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          <StringBox
            name="Reward"
            value={reward.text}
            multiline
            onBlur={(value: string) => {
              reward.text = value;
              changed();
            }}
          />
        </Grid>
        <Grid size={12} className="header">
          Money: { reward.money.toString() }&nbsp;<AddButton onClick={() => setAddingMoney(true) } />
        </Grid>
        <Grid size={12}>
          { renderItems() }
        </Grid>
      </Grid>
      <ModalOrDrawer open={adding_money} onClose={() => setAddingMoney(false)}>
        { adding_money &&
          <CurrencyEditor
            money={reward.money}
            title="Money"
            total_label="Total Reward in GP"
            onChange={changed}
          />
        }
      </ModalOrDrawer>
      <ModalOrDrawer open={adding_items} onClose={() => setAddingItems(false)}>
        { adding_items &&
          <CharacterManageInventory
            obj={campaign}
            shared={false}
            onAddItem={(item: PseudoItem, count: number) => {
              const id = item.id;
              const existing = reward.items.find(o => o.id === id && !o.for_all);
              if (existing) {
                existing.count += count;
              } else {
                reward.items.push({ id, count, for_all: false });
              }
              changed();
            }}
          />
        }
      </ModalOrDrawer>
    </>
  );
}
